<template>
  <div class="search-form">
    <b-row align-h="between">
      <b-col cols="7">
        <b-form @reset="reset" onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              @keyup.enter="query"
              type="search"
              v-model.trim="form.keyword"
              :placeholder="$l('form_label_search')"
            />
            <b-input-group-append>
              <b-button-group>
                <b-button-group slot="reference">
                  <b-button
                    variant="link"
                    size="sm"
                    class="search-dropdown-button"
                    squared
                    @click="openAdvqueryDialog"
                  >
                    {{ $l('INDEX.advanced_search') || '高级搜索' }}
                  </b-button>
                  <b-button variant="primary" size="sm" @click="query">
                    <i class="fa fa-search" />
                  </b-button>
                </b-button-group>
              </b-button-group>
            </b-input-group-append>
            <b-button
              v-if="allow('A')"
              size="sm"
              class="ml-2"
              variant="outline-success"
              @click="$emit('openEditDialog', { type: 'add' })"
            >
              <b-icon-plus></b-icon-plus>
              {{ $l('INDEX.btn_add') || '新增' }}
            </b-button>
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>
    <el-dialog
      :title="$l('INDEX.advanced_search') || '高级搜索'"
      :show-close="true"
      :visible.sync="advqueryDialogVisible"
      width="1000px"
      :close-on-click-modal="false"
      append-to-body
    >
      <el-form ref="form" :model="form" label-width="100px" size="small">
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item :label="$l('INDEX.Status') || '状态'">
              <el-checkbox-group v-model="form.amzControlParamsStatusList">
                <el-checkbox label="N">
                  {{ $l('form_label_amzControlParamsStatus_N') || '草稿' }}
                </el-checkbox>
                <el-checkbox label="Y">
                  {{ $l('form_label_amzControlParamsStatus_Y') || '已审核' }}
                </el-checkbox>
                <el-checkbox label="D">
                  {{ $l('form_label_amzControlParamsStatus_D') || '已删除' }}
                </el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_amzMarketCode') || '市场'"
              prop="amzMarketCode"
            >
              <dict-select
                v-model="form.amzMarketCode"
                url="/master/common/dict/biz"
                :body="regionParams"
                :placeholder="$l('INDEX.tips_select_placeholder') || '请选择'"
                filterable
                clearable
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_categoryCode') || '分类'"
              prop="categoryCode"
            >
              <el-cascader
                :options="categoryTree"
                :props="{
                  emitPath: false,
                  checkStrictly: false,
                  value: 'value',
                  label: 'label',
                }"
                ref="cascaderCategoryTreeRef"
                v-model="form.categoryCode"
                clearable
                filterable
                style="width: 100%"
                :showAllLevels="false"
              >
                <template slot-scope="{ node, data }">
                  <span>{{ data.label }}</span>
                  <span v-if="!node.isLeaf">
                    ({{ data.children.length }})
                  </span>
                </template>
              </el-cascader>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_exchangeCurrencyUnit') || '市场货币'"
              prop="currency"
            >
              <dict-select
                v-model="form.currency"
                url="/master/common/dict/biz"
                :body="currencyUnitParams"
                :placeholder="$l('INDEX.tips_select_placeholder') || '请选择'"
                filterable
                clearable
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_commissionRate') || '佣金比例'"
            >
              <el-row>
                <el-col :span="11">
                  <el-input-number
                    v-model="form.commissionRateStart"
                    :placeholder="$l('INDEX.tips_input_placeholder')"
                    :min="0"
                    :step="1"
                    :precision="2"
                    controls-position="right"
                    style="width:100%"
                  />
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-input-number
                    v-model="form.commissionRateEnd"
                    :placeholder="$l('INDEX.tips_input_placeholder')"
                    :min="0"
                    :step="1"
                    :precision="2"
                    controls-position="right"
                    style="width:100%"
                  />
                </el-col>
              </el-row>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_storageUnitPrice') || '仓储单价'"
            >
              <el-row>
                <el-col :span="11">
                  <el-input-number
                    v-model="form.storageUnitPriceStart"
                    :placeholder="$l('INDEX.tips_input_placeholder')"
                    :min="0"
                    :step="1"
                    :precision="2"
                    controls-position="right"
                    style="width:100%"
                  />
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-input-number
                    v-model="form.storageUnitPriceEnd"
                    :placeholder="$l('INDEX.tips_input_placeholder')"
                    :min="0"
                    :step="1"
                    :precision="2"
                    controls-position="right"
                    style="width:100%"
                  />
                </el-col>
              </el-row>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_shipUnitPrice') || '头程单价'">
              <el-row>
                <el-col :span="11">
                  <el-input-number
                    v-model="form.shipUnitPriceStart"
                    :placeholder="$l('INDEX.tips_input_placeholder')"
                    :min="0"
                    :step="1"
                    :precision="2"
                    controls-position="right"
                    style="width:100%"
                  />
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-input-number
                    v-model="form.shipUnitPriceEnd"
                    :placeholder="$l('INDEX.tips_input_placeholder')"
                    :min="0"
                    :step="1"
                    :precision="2"
                    controls-position="right"
                    style="width:100%"
                  />
                </el-col>
              </el-row>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_tariffsRate') || '关税税率'">
              <el-row>
                <el-col :span="11">
                  <el-input-number
                    v-model="form.tariffsRateStart"
                    :placeholder="$l('INDEX.tips_input_placeholder')"
                    :min="0"
                    :step="1"
                    :precision="2"
                    controls-position="right"
                    style="width:100%"
                  />
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-input-number
                    v-model="form.tariffsRateEnd"
                    :placeholder="$l('INDEX.tips_input_placeholder')"
                    :min="0"
                    :step="1"
                    :precision="2"
                    controls-position="right"
                    style="width:100%"
                  />
                </el-col>
              </el-row>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_refundTaxRate') || '退税率'">
              <el-row>
                <el-col :span="11">
                  <el-input-number
                    v-model="form.refundTaxRateStart"
                    :placeholder="$l('INDEX.tips_input_placeholder')"
                    :min="0"
                    :step="1"
                    :precision="2"
                    controls-position="right"
                    style="width:100%"
                  />
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-input-number
                    v-model="form.refundTaxRateEnd"
                    :placeholder="$l('INDEX.tips_input_placeholder')"
                    :min="0"
                    :step="1"
                    :precision="2"
                    controls-position="right"
                    style="width:100%"
                  />
                </el-col>
              </el-row>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_vatRate') || '增值税率'">
              <el-row>
                <el-col :span="11">
                  <el-input-number
                    v-model="form.vatRateStart"
                    :placeholder="$l('INDEX.tips_input_placeholder')"
                    :min="0"
                    :step="1"
                    :precision="2"
                    controls-position="right"
                    style="width:100%"
                  />
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-input-number
                    v-model="form.vatRateEnd"
                    :placeholder="$l('INDEX.tips_input_placeholder')"
                    :min="0"
                    :step="1"
                    :precision="2"
                    controls-position="right"
                    style="width:100%"
                  />
                </el-col>
              </el-row>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_truckingFee') || '货代卡车费'">
              <el-row>
                <el-col :span="11">
                  <el-input-number
                    v-model="form.truckingFeeStart"
                    :placeholder="$l('INDEX.tips_input_placeholder')"
                    :min="0"
                    :step="1"
                    :precision="2"
                    controls-position="right"
                    style="width:100%"
                  />
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-input-number
                    v-model="form.truckingFeeEnd"
                    :placeholder="$l('INDEX.tips_input_placeholder')"
                    :min="0"
                    :step="1"
                    :precision="2"
                    controls-position="right"
                    style="width:100%"
                  />
                </el-col>
              </el-row>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_freightFee') || '货代头程运费'"
            >
              <el-row>
                <el-col :span="11">
                  <el-input-number
                    v-model="form.freightFeeStart"
                    :placeholder="$l('INDEX.tips_input_placeholder')"
                    :min="0"
                    :step="1"
                    :precision="2"
                    controls-position="right"
                    style="width:100%"
                  />
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-input-number
                    v-model="form.freightFeeEnd"
                    :placeholder="$l('INDEX.tips_input_placeholder')"
                    :min="0"
                    :step="1"
                    :precision="2"
                    controls-position="right"
                    style="width:100%"
                  />
                </el-col>
              </el-row>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-row :gutter="10">
              <el-form-item
                :label="$l('INDEX.table_label_created_date') || '创建时间'"
              >
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.createTimeStart"
                    type="date"
                    size="small"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.createTimeEnd"
                    type="date"
                    size="small"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
          <el-col :span="12">
            <el-row :gutter="10">
              <el-form-item
                :label="$l('INDEX.form_label_modification_time') || '修改时间'"
              >
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.modifyTimeStart"
                    type="date"
                    size="small"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.modifyTimeEnd"
                    type="date"
                    size="small"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeAdvqueryDialog">
          {{ $l('INDEX.btn_cancel_query') || '取消查询' }}
        </el-button>
        <el-button size="small" type="warning" @click="reset">
          {{ $l('INDEX.btn_reset_filter') || '重置条件' }}
        </el-button>
        <el-button size="small" type="primary" @click="advquery">
          {{ $l('INDEX.btn_data_retrieval') || '数据检索' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// 初始表单
const initForm = { keyword: '', amzControlParamsStatusList: ['Y', 'N'] }
export default {
  data() {
    return {
      regionParams: { dictType: 'region' },
      currencyUnitParams: { dictType: 'currencyUnit' },
      categoryTree: [],
      advqueryDialogVisible: false,
      form: { ...initForm },
    }
  },

  mounted() {
    this.getTreeData()
    this.query()
  },
  methods: {
    getTreeData() {
      this.$api
        .ecomAmzSpuCategoryApi({ parentCode: 'ABSHome' })
        .then((res) => {
          this.categoryTree = res.body.data || []
        })
        .catch(() => {})
    },
    query({ isReset = true } = {}) {
      if (isReset) {
        this.$emit('reset')
      }
      this.$emit('query', this.form)
    },
    advquery() {
      this.form.keyword = ''
      this.query()
      this.closeAdvqueryDialog()
    },
    reset() {
      this.form = { ...initForm }
    },
    openAdvqueryDialog() {
      this.advqueryDialogVisible = true
    },
    closeAdvqueryDialog() {
      this.advqueryDialogVisible = false
    },
  },
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px;
}
.line {
  text-align: center;
}
</style>
